export const docCopy = {
  doc_layout_title: "Permulaan untuk belajar TypeScript",
  doc_layout_description:
    "Cari awalan proyek yang menggunakan TypeScript: dari Angular ke React atau Node.js dan CLI.",
  doc_bootstrap_title: "Alat untuk mengawali proyek TypeScript",
  doc_bootstrap_description:
    "Serangkaian alat untuk membangun CLI, Aplikasi Web, API, dan Aplikasi.",
  doc_headline: "Sumber Belajar",
  doc_headline_ts_for_js_title: "TS for JS", // TODO: Remove, unused
  doc_headline_ts_for_js_blurb:
    "An overview of TypeScript for engineers with a JavaScript background", // TODO: Remove, unused
  doc_headline_ts_first_title: "Start with TS", // TODO: Remove, unused
  doc_headline_ts_first_blurb:
    "A beginners introduction to JavaScript and TypeScript", // TODO: Remove, unused
  doc_headline_handbook_title: "Handbook", // TODO: This is not actually used on headline section, should be moved to the doc_learn section
  doc_headline_handbook_blurb: "Referensi bahasa TypeScript",
  doc_headline_examples_title: "Examples", // TODO: Remove, unused
  doc_headline_examples_blurb: "Comprehensive hands-on playground tutorials", // TODO: Remove, unused
  doc_start_a_project: "Mulai Proyek Baru",
  doc_start_a_project_desc:
    "Karena TypeScript adalah bagian dari JavaScript, ia tidak memiliki templat standar - akan ada terlalu banyak. Sebagai gantinya, proyek lainnya memiliki templat awalan TypeScriptnya sendiri dengan konteksnya sendiri pula. Proyek ini menyediakan templat yang menyediakan dukungan TypeScript.",
  doc_node_npm: "Node dengan npm",
  doc_node_npm_tsdx_blurb: "Alat tanpa konfigurasi untuk membangun perpustakaan TypeScript",
  doc_node_npm_oclif_blurb: "Buat alat perintah sebaris (Command line tools) yang dicintai pengguna",
  doc_node_npm_gluegun_blurb:
    "Sebuah alat menyenangkan untuk membangun aplikasi perintah sebaris (Command-line) berbasis TypeScript",
  doc_frameworks: "Kerangka kerja Web",
  doc_frameworks_angular_blurb:
    "Buat penulisan aplikasi yang indah menjadi menyenangkan",
  doc_frameworks_ember_blurb: "Kerangka kerja untuk pengembang web yang ambisius",
  doc_frameworks_react_blurb:
    "Kerangka kerja untuk membangun antarmuka pengguna",
  doc_frameworks_vue_blurb: "Kerangka kerja JavaScript nan Progresif",
  doc_frameworks_ror_blurb: "Kerangka kerja aturan atas konfigurasi (convention over configuration)",
  doc_frameworks_asp_blurb:
    "Kerangka kerja untuk membangun aplikasi modern, berbasis awan dan terhubung dengan Internet.",
  doc_apis: "API Node",
  doc_apis_azure_blurb: "Buat dan luncurkan (deploy) dari VS Code dalam hitungan menit",
  doc_apis_feather_blurb:
    "Sebuah kerangka kerja untuk aplikasi real-time dan REST API",
  doc_apis_graphql_blurb: "Mulai peladen (server) GraphQL Anda dalam hitungan detik",
  doc_apis_nest_blurb:
    "Kerangka kerja Node.js nan progresif untuk membangun aplikasi peladen (server-side) secara efisien dan dapat dikembangkan",
  doc_apis_node_blurb: "Sebuah templat terdokumentasi dari tim TS",
  doc_apis_wechat_blurb: "Gunakan JSSDK WeChat dengan TypeScript",
  doc_apis_loopback_blurb:
    "Kerangka kerja Node.js dan Typescript yang dapat dikembangkan untuk membangun API dan servis mikro (microservices)",
  doc_apis_fastify_blurb: "Sebuah kerangka kerja web yang cepat dan berbiaya rendah untuk Node.js",
  doc_react: "Proyek React",
  doc_react_create_blurb: "Persiapkan aplikasi web modern dengan satu perintah",
  doc_react_gatsby_blurb:
    "Membantu pengembang membangun situs dan aplikasi secara cepat",
  doc_react_next_blurb: "Kerangka Kerja React",
  doc_react_razzle_blurb:
    "Aplikasi JavaScript universal yang di render di peladen (server) tanpa konfigurasi",
  doc_react_toolchains_title: "Rangkaian alat terekomendasi",
  doc_react_toolchains_blurb: "Rekomendasi dari tim React",
  doc_apps: "Membangun Aplikasi",
  doc_apps_electron_blurb:
    "Membangun aplikasi desktop lintas platform menggunakan JavaScript, HTML, dan CSS",
  doc_apps_expo_blurb: "Cara tercepat untuk membangun aplikasi",
  doc_apps_react_native_blurb: "Belajar sekali, tulis dimanapun",
  doc_apps_native_script_blurb:
    "Kerangka kerja sumber terbuka untuk membangun aplikasi mobile yang benar-benar asli (native)",
  doc_apps_make_code_blurb:
    "Bawa ilmu komputer ke kehidupan nyata untuk semua siswa dengan proyek menyenangkan",
  doc_tooling: "Alat (Tooling)",
  doc_tooling_babel_blurb: "Gunakan JavaScript generasi selanjutnya, sekarang",
  doc_tooling_parcel_blurb:
    "Bundler aplikasi web tanpa konfigurasi yang sangat cepat",
  doc_tooling_webpack_blurb: "Bundle aset, script, gambar dan gaya (styles) Anda",
  doc_learn: "Telah familiar dengan TypeScript?",
  doc_learn_3_5_release_notes_title: "Catatan Rilis",
  doc_learn_handbook_blurb: "The TypeScript language reference", // TODO: Remove, unused
  doc_learn_d_ts_title: "Panduan d.ts",
  doc_learn_d_ts_blurb: "Pelajari bagaimana mendeklarasikan bentuk JS",
  doc_learn_playground_blurb: "Eksplor dan bagikan TypeScript secara daring",
}
